/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var Utils = window.OletLens.Utils || {};

  function getFormData() {
    var personNameInput = document.getElementById('person_name_reading');
    var pdCheckbox = document.getElementById('noSamePdReading');
    var isSeparate = !!(pdCheckbox && pdCheckbox.checked);

    var pd = isSeparate
      ? {
          left: parseFloat((document.getElementById('od_pd_reading') || {}).value) || 0,
          right: parseFloat((document.getElementById('os_pd_reading') || {}).value) || 0,
        }
      : {
          combined: parseFloat((document.getElementById('pd_reading') || {}).value) || 0,
        };

    var activeButton = document.querySelector('.magnification-btn.active');
    var strength = activeButton ? activeButton.getAttribute('data-value') : null;

    return {
      person_name: personNameInput ? personNameInput.value : '',
      strength: strength,
      pd: pd,
    };
  }

  function validate() {
    var data = getFormData();
    var errors = [];

    if (!data.strength) {
      errors.push('Please select a reading strength.');
    }
    if (data.pd.combined !== undefined && !data.pd.combined) {
      errors.push('Please select a PD value.');
    }
    if (data.pd.left !== undefined && (!data.pd.left || !data.pd.right)) {
      errors.push('Please select both PD values.');
    }

    return { valid: errors.length === 0, errors: errors };
  }

  function handleMagnificationSelection(value) {
    var buttons = document.querySelectorAll('.magnification-btn');
    buttons.forEach(function (btn) {
      btn.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      if (btn.getAttribute('data-value') === value) {
        btn.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      }
    });
  }

  function handleReadingPDToggle(isSeparate) {
    var readingStep = document.getElementById('step-2.5');
    if (!readingStep) return;

    var singleEls = readingStep.querySelectorAll('.js-pd-add-one');
    var doubleEls = readingStep.querySelectorAll('.js-pd-add-two');
    singleEls.forEach(function (el) {
      el.style.display = isSeparate ? 'none' : '';
    });
    doubleEls.forEach(function (el) {
      el.style.display = isSeparate ? '' : 'none';
      var select = el.querySelector('select');
      if (select) select.disabled = !isSeparate;
    });
  }

  function init(app) {
    var buttons = document.querySelectorAll('.magnification-btn');
    var pdCheckbox = document.getElementById('noSamePdReading');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        handleMagnificationSelection(btn.getAttribute('data-value'));
        if (app && typeof app.setState === 'function') {
          app.setState('reading', getFormData());
        }
      });
    });

    if (pdCheckbox) {
      pdCheckbox.addEventListener('change', function () {
        handleReadingPDToggle(!!pdCheckbox.checked);
      });
    }
  }

  window.OletLens.ReadingModule = {
    init: init,
    getFormData: getFormData,
    validate: validate,
    handleMagnificationSelection: handleMagnificationSelection,
    handleReadingPDToggle: handleReadingPDToggle,
  };
})();
